import { render, staticRenderFns } from "./AdminBreadcrumb.vue?vue&type=template&id=923247d2"
import script from "./AdminBreadcrumb.vue?vue&type=script&lang=js"
export * from "./AdminBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('923247d2')) {
      api.createRecord('923247d2', component.options)
    } else {
      api.reload('923247d2', component.options)
    }
    module.hot.accept("./AdminBreadcrumb.vue?vue&type=template&id=923247d2", function () {
      api.rerender('923247d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminBreadcrumb.vue"
export default component.exports